import { render, staticRenderFns } from "./StudentRequestHistorySlidebar.vue?vue&type=template&id=d99a9bcc"
import script from "./StudentRequestHistorySlidebar.vue?vue&type=script&lang=js"
export * from "./StudentRequestHistorySlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports